// modules
import React, { PureComponent } from 'react';
// import PropTypes from 'prop-types';

// aliased
import Link from 'components/Link';
import SocialLinks from 'components/SocialLinks';

// local
import styles from './Footer.pcss';

const OHSU_GOOGLE_PLACE_ID = 'ChIJxUoxIEcKlVQRGts3_6YLKbc';
const GOOGLE_MAP_API_KEY = 'AIzaSyA0iXNA_U71NAn5vnzFaytgSoGWPXat9u0';

// const joinQuery = (query) => Object
//   .entries(query)
//   .map(([key, value]) => `${ key }=${ value }`)
//   .join('&');
// const OHSU_LAT_LNG = '45.500514,-122.688282';
// const staticMap = (apiKey) => `https://maps.googleapis.com/maps/api/staticmap?${
//   joinQuery({
//     // center: OHSU_LAT_LNG,
//     maptype: 'roadmap',
//     size: '600x300',
//     zoom: 14,
//     key: apiKey,
//     markers: `color:red%7C${ OHSU_LAT_LNG }`,
//   })
//   }`;
//   <a href={ 'https://www.google.com/maps/place/700+SW+Campus+Dr,+Portland,+OR+97239' }>
//     <img src={ staticMap(GOOGLE_MAP_API_KEY) } />
//   </a>


export default class Footer extends PureComponent {
  
  static propTypes = {
  
  }
  static defaultProps = {
    
  }
  

  render() {
    
    return (
      <div id={ 'footer' } className={ styles.footer }>
        <SocialLinks className={ styles.socialLinks } />
        <iframe
          id={ 'map' }
          className={ styles.ohsuMap }
          frameBorder={ 0 }
          title={ 'OHSU Map' }
          src={ `https://www.google.com/maps/embed/v1/place?q=place_id:${ OHSU_GOOGLE_PLACE_ID }&key=${ GOOGLE_MAP_API_KEY }` }
          allowFullScreen={ true } />
        <div className={ styles.bottom }>
          { /* <div className={ styles.copyright }>{ '© 2018 - 2021 Dr. Casey Seideman' }</div> */ }
          <div className={ styles.links }>
            {/* <Link to={ '/privacy-policy' } className={ styles.link } >
              { 'Privacy Policy' }
            </Link> */}
          </div>
          <div className={ styles.madeBy }>
            { 'Site by ' }
            <Link to={ 'https://colby.dauphina.is?utm_source=seideman-md' }>{ 'Colby Dauphinais' }</Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx